module.exports = __webpack_public_path__ + "static/media/des.175662ca.jpg";